var _radialGradient, _linearGradient, _radialGradient2, _linearGradient2, _radialGradient3, _linearGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _linearGradient4, _radialGradient8, _linearGradient5, _radialGradient9, _radialGradient10, _radialGradient11, _radialGradient12, _radialGradient13, _radialGradient14, _radialGradient15, _radialGradient16, _linearGradient6, _radialGradient17, _radialGradient18, _radialGradient19, _radialGradient20, _radialGradient21, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSuitcase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 156.615,
    cy: 376.812,
    gradientTransform: "matrix(1 0 0 .853 0 55.36)",
    gradientUnits: "userSpaceOnUse",
    r: 112.654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#90d8f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4731,
    stopColor: "#6bbef6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5888,
    stopColor: "#66b5eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7907,
    stopColor: "#5a9ece"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a80aa"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfdde2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6376,
    stopColor: "#756e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#716b74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8863,
    stopColor: "#666069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    stopColor: "#544f57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544f57"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 176.436,
    cy: 447.159,
    gradientTransform: "matrix(.707 -.707 .655 .655 -241.095 279.146)",
    gradientUnits: "userSpaceOnUse",
    r: 43.953,
    xlinkHref: "#lg1"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#756e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1679,
    stopColor: "#6f6872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3924,
    stopColor: "#5e5861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4937,
    stopColor: "#544f57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454045"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 162.277,
    cy: 467.909,
    gradientTransform: "matrix(1 0 0 .66 0 158.962)",
    gradientUnits: "userSpaceOnUse",
    r: 56.235,
    xlinkHref: "#lg2"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b818e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1855,
    stopColor: "#837985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#6d646d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5615,
    stopColor: "#665e66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7093,
    stopColor: "#615961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8948,
    stopColor: "#514b51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454045"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 215.83,
    cy: 468.842,
    gradientUnits: "userSpaceOnUse",
    r: 59.055,
    xlinkHref: "#lg3"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 287.873,
    cy: 447.159,
    gradientTransform: "matrix(.707 -.707 .655 .655 -208.455 357.944)",
    gradientUnits: "userSpaceOnUse",
    r: 43.953,
    xlinkHref: "#lg1"
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: 273.714,
    cy: 467.909,
    gradientTransform: "matrix(1 0 0 .66 0 158.962)",
    gradientUnits: "userSpaceOnUse",
    r: 56.235,
    xlinkHref: "#lg2"
  })), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: 327.268,
    cy: 468.842,
    gradientUnits: "userSpaceOnUse",
    r: 59.055,
    xlinkHref: "#lg3"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0067,
    stopColor: "#f1f1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5992,
    stopColor: "#dfdde2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7589,
    stopColor: "#cecad1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9823,
    stopColor: "#afaab4"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: 235.588,
    cy: 117.978,
    gradientTransform: "matrix(-.965 0 0 -2.913 462.219 459.349)",
    gradientUnits: "userSpaceOnUse",
    r: 29.035,
    xlinkHref: "#lg4"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0132,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6064,
    stopColor: "#f1f1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#ededf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9641,
    stopColor: "#e2e0e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dfdde2"
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_9_",
    cx: 194.447,
    cy: 118.696,
    gradientTransform: "matrix(-.891 0 0 -2.913 369.871 462.363)",
    gradientUnits: "userSpaceOnUse",
    r: 29.035,
    xlinkHref: "#lg5"
  })), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_10_",
    cx: 326.85,
    cy: 117.978,
    gradientTransform: "matrix(-.965 0 0 -2.913 638.371 459.349)",
    gradientUnits: "userSpaceOnUse",
    r: 29.035,
    xlinkHref: "#lg4"
  })), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_11_",
    cx: 293.312,
    cy: 118.696,
    gradientTransform: "matrix(-.891 0 0 -2.913 546.023 462.363)",
    gradientUnits: "userSpaceOnUse",
    r: 29.035,
    xlinkHref: "#lg5"
  })), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 204.984,
    cy: 6.312,
    gradientTransform: "matrix(-1 0 0 -.819 409.968 11.483)",
    gradientUnits: "userSpaceOnUse",
    r: 70.188
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfdde2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5721,
    stopColor: "#756e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6974,
    stopColor: "#716b74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8108,
    stopColor: "#666069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9193,
    stopColor: "#544f57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9199,
    stopColor: "#544f57"
  }))), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_13_",
    cx: 289.8,
    cy: 45.22,
    gradientTransform: "matrix(0 1 -1.673 0 365.443 -244.58)",
    gradientUnits: "userSpaceOnUse",
    r: 28.64
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0541,
    stopColor: "#756e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4937,
    stopColor: "#544f57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454045"
  }))), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_14_",
    cx: 293.039,
    cy: 37.799,
    gradientTransform: "matrix(-1 0 0 -.566 586.078 59.195)",
    gradientUnits: "userSpaceOnUse",
    r: 90.898
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b818e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5622,
    stopColor: "#665e66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#615961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#514b51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454045"
  }))), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: 137.353,
    cy: 95.268,
    gradientTransform: "matrix(.36 .933 -.546 .211 139.972 -52.96)",
    gradientUnits: "userSpaceOnUse",
    r: 292.755
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0132,
    stopColor: "#ecf4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1054,
    stopColor: "#e5f3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3496,
    stopColor: "#d8f0fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5693,
    stopColor: "#d3effb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5856,
    stopColor: "#d0eefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8616,
    stopColor: "#a2defa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90d8f9"
  }))), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_16_",
    cx: 313.046,
    cy: 277.398,
    gradientTransform: "matrix(-1 0 0 -.982 626.092 549.802)",
    gradientUnits: "userSpaceOnUse",
    r: 333.079
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.598e-8,
    stopColor: "#90d8f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3919,
    stopColor: "#6bbef6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4934,
    stopColor: "#65b3e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6866,
    stopColor: "#5495c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8925,
    stopColor: "#407093"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.598e-8,
    stopColor: "#90d8f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4983,
    stopColor: "#6bbef6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#417295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407093"
  }))), _radialGradient17 || (_radialGradient17 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_17_",
    cx: 282.394,
    cy: 301.558,
    gradientTransform: "matrix(-1 0 0 -2.328 564.787 1003.534)",
    gradientUnits: "userSpaceOnUse",
    r: 111.347,
    xlinkHref: "#lg6"
  })), _radialGradient18 || (_radialGradient18 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_18_",
    cx: 324.174,
    cy: 301.558,
    gradientTransform: "matrix(-1 0 0 -2.328 648.348 1003.534)",
    gradientUnits: "userSpaceOnUse",
    r: 111.347,
    xlinkHref: "#lg6"
  })), _radialGradient19 || (_radialGradient19 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_19_",
    cx: 365.955,
    cy: 301.558,
    gradientTransform: "matrix(-1 0 0 -2.328 731.909 1003.534)",
    gradientUnits: "userSpaceOnUse",
    r: 111.347,
    xlinkHref: "#lg6"
  })), _radialGradient20 || (_radialGradient20 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_20_",
    cx: 407.735,
    cy: 301.558,
    gradientTransform: "matrix(-1 0 0 -2.328 815.47 1003.534)",
    gradientUnits: "userSpaceOnUse",
    r: 111.347,
    xlinkHref: "#lg6"
  })), _radialGradient21 || (_radialGradient21 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_21_",
    cx: 275.138,
    cy: 2825.199,
    gradientTransform: "matrix(.931 0 0 .112 -2.094 178.707)",
    gradientUnits: "userSpaceOnUse",
    r: 149.945
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a298a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1567,
    stopColor: "#c0bac3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3265,
    stopColor: "#dbd8de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4722,
    stopColor: "#ebeaee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5756,
    stopColor: "#f1f1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    stopColor: "#f6f6f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m190.117 378.778-55.913 8.486v22.833c0 17.825 14.45 32.275 32.275 32.275h75.975z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.939 442.372h-17.314c-14.305 0-25.902 11.597-25.902 25.902l22.355 2.839z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.227 468.274h-20.505c0 14.305 11.597 25.902 25.902 25.902h17.314z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.939,
    cy: 468.274,
    fill: "url(#SVGID_4_)",
    r: 25.902
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.376 442.372h-17.314c-14.305 0-25.902 11.597-25.902 25.902l22.355 2.839z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.664 468.274h-20.505c0 14.305 11.597 25.902 25.902 25.902h17.314z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.376,
    cy: 468.274,
    fill: "url(#SVGID_7_)",
    r: 25.902
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.121 38.823h14.898v85.947h-14.898z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.369 38.823h13.752v85.947h-13.752z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m299.197 38.823h14.898v85.947h-14.898z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.445 38.823h13.752v85.947h-13.752z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232.842 0h-15.134c-11.996 0-21.721 9.725-21.721 21.721v26.529h15.134z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.157 16.815c2.705 0 4.906 2.201 4.906 4.906v26.529h15.134l1.85-32.938z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.291 0h-61.449c-11.996 0-21.721 9.725-21.721 21.721v26.529h16.815v-26.529c0-2.705 2.201-4.906 4.906-4.906h61.449c2.705 0 4.906 2.201 4.906 4.906v26.529h16.815v-26.529c.001-11.996-9.724-21.721-21.721-21.721z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.454 116.58h-75.975c-17.825 0-32.276 14.45-32.276 32.276v238.409h53.142z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345.521 442.372h-125.899c-17.825 0-32.275-14.45-32.275-32.275v-261.242c0-17.825 14.45-32.275 32.275-32.275h125.899c17.825 0 32.275 14.45 32.275 32.275v261.241c0 17.826-14.45 32.276-32.275 32.276z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.346 149.133v260.684c0 5.769-4.676 10.445-10.445 10.445h-.001c-5.769 0-10.445-4.676-10.445-10.445v-260.683c0-5.745 4.7-10.445 10.445-10.445 5.769-.001 10.446 4.676 10.446 10.444z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.126 149.133v260.684c0 5.769-4.676 10.445-10.445 10.445h-.001c-5.769 0-10.445-4.676-10.445-10.445v-260.683c0-5.745 4.7-10.445 10.445-10.445 5.77-.001 10.446 4.676 10.446 10.444z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.907 149.133v260.684c0 5.769-4.676 10.445-10.445 10.445h-.001c-5.769 0-10.445-4.676-10.445-10.445v-260.683c0-5.745 4.7-10.445 10.445-10.445 5.769-.001 10.446 4.676 10.446 10.444z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m355.687 149.133v260.684c0 5.769-4.676 10.445-10.445 10.445h-.001c-5.769 0-10.445-4.676-10.445-10.445v-260.683c0-5.745 4.7-10.445 10.445-10.445 5.77-.001 10.446 4.676 10.446 10.444z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 512c80.346 0 145.479-7.98 145.479-17.824h-290.958c0 9.844 65.133 17.824 145.479 17.824z",
    fill: "url(#SVGID_21_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuitcase);
export default __webpack_public_path__ + "static/media/icon-suitcase.59d7e4a30237a944dae2359e411dba22.svg";
export { ForwardRef as ReactComponent };